import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoBg: CultureInfo = {
  name: 'bg',
  displayName: 'Bulgarian',
  iso3LanguageCode: 'bul',
  iso2LanguageCode: 'bg',
  ietfLanguageTag: 'bg',
  parent: null
};
